import * as moment from "moment";
import {Moment} from "moment";


export class UtilsService {

  static instance = new UtilsService();

  getDescriptionFromDateTime(date: string, time: string): string {
    const momentObj = moment(date + " " + time);
    if (momentObj.isValid()) {
      return momentObj.format("DD MMMM YYYY - HH:mm");
    } else {
      return "";
    }
  }

  getDescriptionFromISO8601(date: string): string {
    const momentObj = moment(date, moment.ISO_8601);
    if (momentObj.isValid()) {
      return momentObj.format("DD MMMM YYYY - HH:mm");
    } else {
      return "";
    }
  }

  getMomentFromDateTime(date: string, time: string): Moment {
    // TODO calendar converting +2
    return moment.utc(date + " " + time).local();
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/services/utilsService.ts